(() => {
  'use strict';

  const media = window.matchMedia('(max-width: 749px)');
  const originalElements = new WeakMap();
  const originalChildren = new WeakMap();

  const rememberElement = (element) => {
    if (!element || originalElements.has(element)) return;
    originalElements.set(element, { html: element.innerHTML, hidden: element.hidden });
  };

  const setMobileHtml = (element, mobileHtml) => {
    if (!element) return;
    rememberElement(element);
    const original = originalElements.get(element);
    const nextHtml = media.matches ? mobileHtml : original.html;
    if (element.innerHTML !== nextHtml) element.innerHTML = nextHtml;
    if (!media.matches && element.hidden !== original.hidden) element.hidden = original.hidden;
  };

  const rememberContainer = (container) => {
    if (!container || originalChildren.has(container)) return;
    originalChildren.set(container, [...container.children].map((child) => ({
      child,
      html: child.innerHTML,
      hidden: child.hidden,
    })));
  };

  const setMobileLabels = (container, labels) => {
    if (!container) return;
    rememberContainer(container);
    const original = originalChildren.get(container);
    original.forEach(({ child, html, hidden }, index) => {
      if (!child.isConnected) return;
      const nextHtml = media.matches && index < labels.length ? labels[index] : html;
      const nextHidden = media.matches ? index >= labels.length : hidden;
      if (child.innerHTML !== nextHtml) child.innerHTML = nextHtml;
      if (child.hidden !== nextHidden) child.hidden = nextHidden;
    });
  };

  const collectionLabels = {
    'nieuw-verschenen': ['Nieuwe MatchBoox<br>uitgaven', 'Handgemaakt in<br>kleine oplagen'],
    'meest-verkocht': ['Geliefde series<br>uit het fonds', 'Compleet in luxe<br>geschenkdoos'],
    series: ['Vier boekjes<br>80 pagina’s', 'Compleet in luxe<br>geschenkdoos'],
    'losse-boekjes': ['Losse boekjes<br>20 pagina’s', 'Handgemaakt<br>sinds 2009'],
    'alle-matchboox': ['Het volledige<br>MatchBoox-fonds', 'Losse boekjes<br>en series'],
  };

  const updateUsps = (scope = document) => {
    scope.querySelectorAll?.('.mb-collection-hero[data-collection-handle]').forEach((hero) => {
      const labels = collectionLabels[hero.dataset.collectionHandle];
      if (labels) setMobileLabels(hero.querySelector('.mb-collection-hero__usps'), labels);
    });

    scope.querySelectorAll?.('.mb-page-content[data-page-handle="auteurs"]').forEach((page) => {
      setMobileLabels(page.querySelector('.mb-v126-maker-hero .mb-usp'), [
        'Nederlandse en Vlaamse<br>auteurs',
        'Boekjes en series<br>per auteur',
      ]);
    });

    scope.querySelectorAll?.('.mb-page-content[data-page-handle="illustratoren"]').forEach((page) => {
      setMobileLabels(page.querySelector('.mb-v126-maker-hero .mb-usp'), page.dataset.mbRealHandle === 'vormgevers' ? [
        'Vormgevers en<br>typografen',
        'Boekjes en series<br>per vormgever',
      ] : [
        'Illustratoren en<br>kunstenaars',
        'Boekjes en series<br>per illustrator',
      ]);
    });

    setMobileLabels(scope.querySelector?.('#mb-what-v17 .mb-v119-editorial-usps'), [
      'Harmonicavorm',
      'Handgemaakt',
    ]);

    setMobileLabels(scope.querySelector?.('.mb-page-content[data-page-handle="bestelinformatie"] .mb-standard-hero-usps'), [
      'Gratis verzending',
      'Track &amp; Trace',
    ]);

    setMobileLabels(scope.querySelector?.('.mb-page-content[data-page-handle="cadeauservice"] .mb-gift-service__usps'), [
      '<strong>Persoonlijke<br>boodschap</strong>',
      '<strong>Direct laten<br>bezorgen</strong>',
    ]);

    scope.querySelectorAll?.('.section-matchboox-home .mb40__why-proof').forEach((proof) => {
      const score = [...proof.children].find((item) => /klantcijfer/i.test(item.textContent));
      setMobileHtml(score, 'Klantcijfer: 9,8 / 10');
    });
  };

  const updateCopy = (scope = document) => {
    scope.querySelectorAll?.('.section-matchboox-home .mb40__chooser-help-copy > p').forEach((paragraph) => {
      setMobileHtml(paragraph, 'U ontvangt direct een persoonlijk<br>cadeauadvies uit de collectie');
    });

    scope.querySelectorAll?.('.section-matchboox-home .mb40__story-block:first-child .mb40__story-copy h2').forEach((heading) => {
      setMobileHtml(heading, 'Ontwerp uw<br>eigen MatchBoox');
    });

    scope.querySelectorAll?.('.mb-page-shell:has(.mb-page-content[data-page-handle="word-zelf-maker"])').forEach((page) => {
      setMobileHtml(page.querySelector('#MbMakerPageTitle'), 'Uw verhaal in<br>uw eigen MatchBoox');
      setMobileHtml(page.querySelector('#MbMakerFormTitle'), 'Leg uw idee<br>aan ons voor');
    });

    scope.querySelectorAll?.('.mb-discovery__back-to-choices').forEach((button) => {
      setMobileHtml(button, '↑ Terug naar keuze');
    });
  };

  const updateMobileVideo = (scope = document) => {
    scope.querySelectorAll?.('.section-matchboox-home .mb40__hero-video').forEach((video) => {
      if (!originalElements.has(video)) originalElements.set(video, { controls: video.controls });
      const original = originalElements.get(video);
      video.controls = media.matches ? false : Boolean(original.controls);
    });
  };

  const reinforceSearchPrivacy = (scope = document) => {
    if (!media.matches) return;
    scope.querySelectorAll?.('input[type="search"]').forEach((input) => {
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('spellcheck', 'false');
      input.setAttribute('data-1p-ignore', 'true');
      input.setAttribute('data-lpignore', 'true');
    });
  };

  const apply = (scope = document) => {
    updateUsps(scope);
    updateCopy(scope);
    updateMobileVideo(scope);
    reinforceSearchPrivacy(scope);
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  };

  const init = () => {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    media.addEventListener?.('change', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', (event) => apply(event.target));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
